import { Stack } from '@mantine/core';
import { NavigationWrapper } from '../components/navigation/NavigationWrapper';
import { TopicAvailabilityManagement } from '../components/topics/TopicAvailabilityManagement';

export const AvailabilityManagement = () => {
  return (
    <NavigationWrapper>
      <Stack align="center">
        <TopicAvailabilityManagement />
      </Stack>
    </NavigationWrapper>
  );
};
